import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';  
import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'
import { IconButton } from '@material-ui/core';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

const SelectComp = (props) => { 

    return (
        <FormControl style={{...props.style}} variant={props.variant ? props.variant : "outlined"} className={props.className} error={props.error}> 
            {props.label &&
              <InputLabel id="demo-simple-select-outlined-label">{props.label}</InputLabel>
            }
            <Select  
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={props.value}
                onChange={props.onChange} 
                label={props.label}
                
                endAdornment={
                    props.deleteIcon &&
                    <InputAdornment position="end">
                        <IconButton onClick={props.onDelete}>
                            <DeleteRoundedIcon />
                        </IconButton>    
                    </InputAdornment>}
            > 
                {props.options.map((val,index) => {
                    return (
                        <MenuItem value={props.values[index]} style={{fontSize: '14px'}}>{val}</MenuItem>            
                    )
                })} 
            </Select>
            {props.error && <FormHelperText>
                {props.error}
            </FormHelperText>}
        </FormControl>
    )
}

export default SelectComp;